import { createFileRoute } from "@tanstack/react-router";
import CardReadPage from "@/site/pages/card-read";

/**
 * The recipient card-read page (legacy `/card/read/<magic_link>`). The optional
 * `?dt=<delivery_token>` is the per-recipient open-tracking token (parity with the
 * legacy `?t=`); passing it stamps the first open + unlocks an anonymous thank-you.
 * URL shape is a hard constraint (PRD 03 §8.4) — links are already in the wild.
 */
type CardReadSearch = { dt?: string };

export const Route = createFileRoute("/card/read/$slug")({
  component: CardReadPage,
  validateSearch: (search: Record<string, unknown>): CardReadSearch => ({
    dt: typeof search.dt === "string" && search.dt ? search.dt : undefined,
  }),
});
